import { Component, inject } from '@angular/core'
import { CommonModule } from '@angular/common'
import { FormsModule } from '@angular/forms'
import { IonicModule } from '@ionic/angular'
import { PrivateMessageQueryType } from '../../../../models/privateMessage'
import { MessagingPageService } from '../../../../pages/messaging/messaging/messaging-page.service'

export type ToggleablePrivateMessageType = PrivateMessageQueryType.direct | PrivateMessageQueryType.feedback

@Component({
  selector: 'app-private-message-type-toggle',
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule],
  templateUrl: './private-message-type-toggle.component.html',
  styleUrls: ['./private-message-type-toggle.component.scss'],
})
export class PrivateMessageTypeToggleComponent {
  private messagingService = inject(MessagingPageService)

  TAG = 'PrivateMessageTypeToggleComponent'

  // @Output() messageQueryTypeChanged = new EventEmitter<ToggleablePrivateMessageType>()

  toggleValue = false
  messageType: ToggleablePrivateMessageType = PrivateMessageQueryType.feedback
  MsgType = PrivateMessageQueryType

  // ngOnChanges(changes: NgChanges<ClientSessionTypeToggleComponent>): void {
  //   if (changes.isInitiallyDirectWork?.currentValue != changes.isInitiallyDirectWork?.previousValue) {
  //     console.log(this.TAG, 'ngOnChanges', this.isInitiallyDirectWork)
  //     this.changeWorktype(this.isInitiallyDirectWork)
  //     // console.log('toggleValue', this.toggleValue)
  //     this.toggleValue = !this.isInitiallyDirectWork
  //     // this.toggleChanged(this.toggleValue)
  //   }
  // }

  toggleChanged(isFeedback: boolean): void {
    console.log(this.TAG, 'toggleValue', this.toggleValue)
    this.changeMessageType(!isFeedback)
  }

  changeMessageType(isFeedback: boolean): void {
    setTimeout(() => {
      this.messageType = isFeedback ? PrivateMessageQueryType.feedback : PrivateMessageQueryType.direct
      this.messagingService.setPrivateMessageType(this.messageType)
      // this.messageQueryTypeChanged.emit(this.messageType)
    })
  }
}
